import { render } from "./NewsAdmin.vue?vue&type=template&id=5d79f29a&scoped=true"
import script from "./NewsAdmin.vue?vue&type=script&lang=js"
export * from "./NewsAdmin.vue?vue&type=script&lang=js"

import "./NewsAdmin.vue?vue&type=style&index=0&id=5d79f29a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d79f29a"]])

export default __exports__